import { CSSProperties } from 'react';
import { createUseStyles } from '@glu/theming';

const styles = {
  box: (sx: CSSProperties) => ({
    ...sx,
  }),
};

export default createUseStyles(styles);
